import {
  APP_RESIZE,
  KEY_COLLECTION,
  APP_KEYBOARD_ENABLED,
  ADVANCED_SEARCH_ENABLED,
  ADVANCED_SEARCH_VISIBLE,
  ASSET_TYPE,
  EDIT_MY_ACCOUNT_VISIBLE,
  SELECTED_CP_ACTIVITY_LOG_VALUE,
  SELECTED_FOLDER_EXPLORE,
  ADVANCED_SEARCH_VALUES_FROM_NAVBAR
} from "../constants/app-types";

export const setWidth = width => {
  return dispatch => {
    dispatch({ type: APP_RESIZE, payload: width });
  };
};

export const setKeyCollection = collection => {
  return dispatch => {
    dispatch({ type: KEY_COLLECTION, payload: collection });
  };
};

export const setkeyboardEnabled = isEnabled => {
  return dispatch => {
    dispatch({ type: APP_KEYBOARD_ENABLED, payload: isEnabled });
  };
};

export const setAdvancedSearchEnabled = isEnabled => {
  return dispatch => {
    dispatch({ type: ADVANCED_SEARCH_ENABLED, payload: isEnabled });
  };
};

export const setAdvancedSearchValuesFromNavBar = values => {
  return dispatch => {
    dispatch({ type: ADVANCED_SEARCH_VALUES_FROM_NAVBAR, payload: values });
  };
};

// Búsqueda por tag desde el detalle de un asset. Antes hacía una búsqueda de texto suelta
// (getSearchResult) que dejaba el panel de búsqueda avanzada con el NOMBRE viejo y sin el
// tag → confundía al usuario. Ahora enruta por el mismo mecanismo del buscador avanzado:
// pone el tag en el filtro de tags, limpia el nombre y abre el panel avanzado para que se
// VEA qué se está filtrando. AdvancedSearch reacciona a estos valores y dispara la búsqueda.
export const searchByTagFromDetail = tag => dispatch => {
  dispatch(
    setAdvancedSearchValuesFromNavBar({ searchText: "", searchType: "all", tags: [tag] })
  );
  dispatch(setAdvancedSearchEnabled(true));
};

export const setAssetType = assetType => {
  return dispatch => {
    dispatch({ type: ASSET_TYPE, payload: assetType });
  };
};

export const setEditMyAccountVisible = isVisible => {
  return dispatch => {
    dispatch({ type: EDIT_MY_ACCOUNT_VISIBLE, payload: isVisible });
  };
};

export const setAdvancedSearchVisible = isVisible => {
  return dispatch => {
    dispatch({ type: ADVANCED_SEARCH_VISIBLE, payload: isVisible });
  };
};

export const setCpActivityLogSelectedValue = valueSelected => {
  return dispatch => {
    dispatch({ type: SELECTED_CP_ACTIVITY_LOG_VALUE, payload: valueSelected });
  };
};
export const setSelectedFolderExplore = valueSelected => {
  return dispatch => {
    dispatch({ type: SELECTED_FOLDER_EXPLORE, payload: valueSelected });
  };
};
